import { useState } from 'react'

const useLazyFirestoreCatalog = ({ loadCatalog, errorMessage, logLabel }) => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [loadError, setLoadError] = useState('')
  const [isRequested, setIsRequested] = useState(false)

  const load = () => {
    if (isRequested) {
      return
    }

    setIsRequested(true)
    setIsLoading(true)
    setLoadError('')

    loadCatalog()
      .then((nextData) => {
        setData(nextData)
      })
      .catch((error) => {
        console.error(logLabel, error)
        setLoadError(errorMessage)
        setIsRequested(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return {
    data,
    isLoading,
    loadError,
    load,
  }
}

export default useLazyFirestoreCatalog
